import styled from 'styled-components'

import { style } from 'theme'

const Heading2 = styled.h3`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  margin: 0;
`

export default Heading2
